/** A subscription is billed every 4 weeks, so "1 call a week" is exactly 4 calls a charge. */
export const SUBSCRIPTION_PERIOD_WEEKS = 4;

/** 0 is the membership: posts and quiz answers, no calls. */
export const CALLS_PER_WEEK_OPTIONS = [0, 1, 2, 3];

export const PLAN_MINUTES_OPTIONS = [15, 30, 45, 60, 90];

/** A pause is whole weeks, so the weekly blocks keep their place. */
export const PAUSE_WEEKS_OPTIONS = [1, 2, 3, 4];

export const WEEK_MS = 7 * 24 * 60 * 60 * 1000;

/**
 * The start of the 7-day block `at` falls in. Weeks are counted from the
 * subscription's start, not the calendar, so they are the same in every timezone.
 */
export function weekStartOf(startedAt: Date, at: Date): Date {
  const weeks = Math.floor((at.getTime() - startedAt.getTime()) / WEEK_MS);
  return new Date(startedAt.getTime() + weeks * WEEK_MS);
}

/** The checkout and invoice line: "1 call a week (60 min calls) with anna". */
export function formatSubscriptionLine({
  callsPerWeek,
  callMinutes,
  username,
}: {
  callsPerWeek: number;
  callMinutes: number;
  username: string;
}): string {
  if (callsPerWeek === 0) return `${planName(callsPerWeek)} with ${username}`;
  return `${planName(callsPerWeek)} (${callMinutes} min calls) with ${username}`;
}

/**
 * What switching plans is: more calls a week is up (now, prorated), fewer is down (at the
 * renewal), the same tier is no move, so a re-priced tier never moves a subscriber.
 */
export function planMove(
  current: { callsPerWeek: number },
  target: { callsPerWeek: number },
): 'up' | 'down' | 'none' {
  if (target.callsPerWeek > current.callsPerWeek) return 'up';
  return target.callsPerWeek < current.callsPerWeek ? 'down' : 'none';
}

export function planName(callsPerWeek: number): string {
  if (callsPerWeek === 0) return 'Membership';
  return callsPerWeek === 1 ? '1 call a week' : `${callsPerWeek} calls a week`;
}
